export default {
  eyebrow: 'Bc',
  heading: 'Business consultancy.',
  copy: 'We help you understand a better future for your business, then we help you deliver it.',
  component: 'm-card-practice',
}
